import { useEffect, useState } from "react";

// Breakpoints EXACTOS de la referencia (renderVals, líneas 3424-3427):
//   isMobile   = w < 768
//   isTablet   = w >= 768 && w < 1100
//   compactNav = w < 1024
//   stack      = w < 900
export function useViewport() {
  const [w, setW] = useState(() => (typeof window !== "undefined" ? window.innerWidth : 1200));
  useEffect(() => {
    // rAF-coalesce: una ráfaga de resize/orientation produce un solo setW por
    // frame (mismo valor final), sin re-renders intermedios que compitan con un
    // gesto en curso. window.innerWidth se lee en el rAF (valor más reciente).
    let raf: number | null = null;
    const onResize = () => {
      if (raf != null) return;
      raf = requestAnimationFrame(() => { raf = null; setW(window.innerWidth); });
    };
    window.addEventListener("resize", onResize);
    return () => { window.removeEventListener("resize", onResize); if (raf != null) cancelAnimationFrame(raf); };
  }, []);
  return {
    w,
    isMobile: w < 768,
    isTablet: w >= 768 && w < 1100,
    compactNav: w < 1024,
    stack: w < 900,
  };
}
